export default {"src":"/_next/static/media/why-2.c4ab0fb3.svg","height":24,"width":29};